let focusTrap = null;

function getFocusableElements(container) {
  return Array.from(container.querySelectorAll(
    "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
  )).filter((element) => {
    if (!(element instanceof HTMLElement) || element.matches(':disabled') || element.tabIndex < 0) return false;
    if (element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    if (!element.getClientRects().length) return false;
    const style = getComputedStyle(element);
    return style.visibility !== 'hidden' && style.visibility !== 'collapse';
  });
}

export function trapFocus(container) {
  removeTrapFocus();
  const addedTabindex = !(container instanceof HTMLDialogElement) && !container.hasAttribute('tabindex');
  if (addedTabindex) container.setAttribute('tabindex', '-1');
  const focusFirst = () => (getFocusableElements(container)[0] || container).focus({ preventScroll: true });
  const keydown = (event) => {
    if (event.key !== 'Tab') return;
    const focusable = getFocusableElements(container);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    if (!focusable.length) {
      event.preventDefault();
      container.focus({ preventScroll: true });
    } else if (!event.shiftKey && (active === last || !container.contains(active))) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && (active === first || active === container || !container.contains(active))) {
      event.preventDefault();
      last.focus();
    }
  };
  const focusin = (event) => {
    if (event.target instanceof Node && !container.contains(event.target)) {
      event.stopPropagation();
      focusFirst();
    }
  };
  focusTrap = { container, keydown, focusin, addedTabindex };
  document.addEventListener('keydown', keydown, true);
  document.addEventListener('focusin', focusin, true);
  if (!container.contains(document.activeElement)) focusFirst();
}

export function removeTrapFocus(container) {
  if (!focusTrap || (container && container !== focusTrap.container && !container.contains(focusTrap.container))) return;
  document.removeEventListener('keydown', focusTrap.keydown, true);
  document.removeEventListener('focusin', focusTrap.focusin, true);
  if (focusTrap.addedTabindex) focusTrap.container.removeAttribute('tabindex');
  focusTrap = null;
}

/**
 * Cycle focus to the next or previous link
 *
 * @param {HTMLElement[]} items
 * @param {number} increment
 */
export function cycleFocus(items, increment) {
  const currentIndex = items.findIndex((item) => item.matches(':focus'));
  let targetIndex = currentIndex + increment;

  if (targetIndex >= items.length) {
    targetIndex = 0;
  } else if (targetIndex < 0) {
    targetIndex = items.length - 1;
  }

  const targetItem = items[targetIndex];

  if (!targetItem) return;

  targetItem.focus();
}
